import { createSortOption } from "@nosto/preact"
export const sizes = [24, 48, 72]

export const sortOptions = [
    createSortOption("score", "Most relevant", { field: "_score", order: "desc" }),
    createSortOption("-price", "Price descending", { field: "price", order: "desc" }),
    createSortOption("price", "Price ascending", { field: "price", order: "asc" }),
    createSortOption("-date published", "Newest", { field: "datePublished", order: "desc" }),
    createSortOption("-sales", "Best Sellers", { field: "stats.buys", order: "desc" }),
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[0],
    autocompleteProductsSize: 4,
    autocompleteKeywordsSize: 5,
    historySize: 5
}
